module.exports = __webpack_public_path__ + "static/img/logo.8f32d92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/logo.png
// module id = vJvE
// module chunks = 44